import { useState } from 'react';
import Shelf from './Shelf';

function App() {
  return (
    <div className="container">
      <h1>Jaz Gulati</h1>
      <p className="updated">Updated: <time dateTime="2026-10-04">October 4, 2026</time></p>
      <h2>About me:</h2>
      <ul>
        <li>Bringing clarity to complex systems
          <ul>
            <li>Now: Running <a href="https://grassroots.studio" rel="noreferrer" target="_blank">Grassroots Studio</a>, a design and technology studio</li>
            <li>Now: Building <a href="https://garden.finance" rel="noreferrer" target="_blank">Garden</a>, Binance but on-chain</li>
            <li>Past: Worked on <a href="https://renprotocol.org" rel="noreferrer" target="_blank">Ren</a> (acquired by <Tooltip text="FTX" tooltipText="🥴" />), a protocol that enables the movement of value between blockchains</li>
            <li>Past: Built a wagering platform with <Tooltip text="3AC" tooltipText="😵‍💫" /></li>
          </ul>
        </li>
      </ul>
      <h2>Collection:</h2>
      <Shelf />
    </div>
  );
}

const Tooltip = ({ text, tooltipText }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };

  return (
    <div
      className="tooltipText"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      {text}
      {visible && (
        <div
          className="tooltip"
          style={{ top: position.y, left: position.x, transform: 'translate(-50%, -120%)' }}
        >
          {tooltipText}
        </div>
      )}
    </div>
  );
};

export default App;
